<template>
  <div>
    <!-- 搜索和操作栏 -->
    <div style="margin: 10px 0">
      <el-input
        style="width: 200px;"
        v-model="searchName"
        placeholder="请输入设备名称"
        suffix-icon="el-icon-search"
        clearable
        @clear="load"
        @keyup.enter.native="load"
      ></el-input>
      <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button>

      <!-- 公司筛选 -->
      <el-select v-if="user.role === '超级管理员'" v-model="searchCompanyId" placeholder="选择公司" clearable style="margin-left: 10px; width: 120px;" @change="onCompanyFilterChange">
        <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id"></el-option>
      </el-select>

      <!-- 大棚筛选（根据所选公司动态切换） -->
      <el-select v-model="searchGreenhouseId" placeholder="选择大棚" clearable style="margin-left: 10px; width: 120px;" @change="load">
        <el-option v-for="greenhouse in filteredGreenhouses" :key="greenhouse.id" :label="greenhouse.name" :value="greenhouse.id"></el-option>
      </el-select>

      <el-button v-if="user.role !== '用户'" style="float:right; margin-left: 10px" type="danger" @click="deleteBatch">批量删除</el-button>
      <el-button v-if="user.role !== '用户'" style="float:right;" type="primary" @click="handleAdd" icon="el-icon-circle-plus-outline">新增设备</el-button>
    </div>

    <!-- 设备列表 -->
    <el-table
      :data="tableData"
      border
      stripe
      :header-cell-class-name="headerBg"
      @selection-change="handleSelectionChange"
    >
      <el-table-column v-if="user.role !== '用户'" type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="deviceName" label="设备名称" min-width="140"></el-table-column>
      <el-table-column prop="sid" label="设备SID" min-width="120"></el-table-column>
      <el-table-column prop="deviceType" label="设备类型" min-width="100"></el-table-column>
      <el-table-column prop="deviceModel" label="设备型号" min-width="120"></el-table-column>
      <el-table-column prop="companyName" label="所属公司" min-width="120"></el-table-column>
      <el-table-column prop="greenhouseName" label="所属大棚" min-width="120"></el-table-column>
      <el-table-column prop="deviceLocation" label="安装位置" min-width="120"></el-table-column>
      <el-table-column label="状态" min-width="80">
        <template slot-scope="scope">
          <el-tag type="success">在线</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
      <el-table-column v-if="user.role !== '用户'" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)" style="margin-right: 5px">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div style="padding: 10px 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" :before-close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="设备名称" prop="deviceName">
              <el-input v-model="form.deviceName" placeholder="请输入设备名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备SID" prop="sid">
              <el-input v-model="form.sid" placeholder="请输入设备SID"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="设备类型" prop="deviceType">
              <el-input v-model="form.deviceType" placeholder="请输入设备类型"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备型号" prop="deviceModel">
              <el-input v-model="form.deviceModel" placeholder="请输入设备型号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="安装位置" prop="deviceLocation">
              <el-input v-model="form.deviceLocation" placeholder="请输入安装位置"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备状态" prop="status">
              <el-select v-model="form.status" placeholder="选择设备状态">
                <el-option label="离线" :value="0"></el-option>
                <el-option label="在线" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 所属公司（仅超级管理员可见） -->
        <el-row :gutter="20" v-if="user.role === '超级管理员'">
          <el-col :span="12">
            <el-form-item label="所属公司" prop="companyId">
              <el-select v-model="form.companyId" placeholder="选择所属公司" @change="onCompanyChange">
                <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属大棚" prop="greenhouseId">
              <el-select v-model="form.greenhouseId" placeholder="选择所属大棚">
                <el-option v-for="greenhouse in filteredGreenhouses" :key="greenhouse.id" :label="greenhouse.name" :value="greenhouse.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 所属大棚（管理员和用户可见，自动限定本公司大棚） -->
        <el-row :gutter="20" v-if="user.role === '管理员' || user.role === '用户'">
          <el-col :span="24">
            <el-form-item label="所属大棚" prop="greenhouseId">
              <el-select v-model="form.greenhouseId" placeholder="选择所属大棚" style="width: 50%;">
                <el-option v-for="greenhouse in filteredGreenhouses" :key="greenhouse.id" :label="greenhouse.name" :value="greenhouse.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 传感器字段配置 -->
        <el-divider>传感器字段配置</el-divider>

        <div v-for="(field, index) in form.fields" :key="index" style="margin-bottom: 10px;">
          <el-card shadow="never">
            <div slot="header" class="clearfix">
              <span>字段 {{ index + 1 }}</span>
              <el-button v-if="form.fields.length > 1" style="float: right; padding: 3px 0" type="text" @click="removeField(index)">删除</el-button>
            </div>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="'测量属性'" :prop="'fields.' + index + '.sensorField'" :rules="[{ required: true, message: '请输入测量属性', trigger: 'blur' }]">
                  <el-input v-model="field.sensorField" placeholder="如：温度"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="'PID'" :prop="'fields.' + index + '.pid'" :rules="[{ required: true, message: '请输入PID', trigger: 'blur' }]">
                  <el-input v-model="field.pid" placeholder="如：temp1"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="'单位'" :prop="'fields.' + index + '.unit'">
                  <el-input v-model="field.unit" placeholder="如：°C"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </div>

        <el-button type="primary" @click="addField" icon="el-icon-plus">添加字段</el-button>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SensorDevice",
  data() {
    return {
      tableData: [],
      searchName: '',
      searchCompanyId: null,
      searchGreenhouseId: null,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '新增设备',
      isEdit: false,
      submitLoading: false,
      multipleSelection: [],
      headerBg: 'headerBg',
      user: JSON.parse(localStorage.getItem("user") || '{}'),
      companies: [],
      greenhouses: [],
      filteredGreenhouses: [],

      form: {
        id: null,
        deviceName: '',
        sid: '',
        deviceType: '',
        deviceModel: '',
        deviceLocation: '',
        status: 0,
        companyId: null,
        greenhouseId: null,
        fields: [{
          sensorField: '',
          pid: '',
          unit: '',
        }]
      },

      rules: {
        deviceName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        sid: [
          { required: true, message: '请输入设备SID', trigger: 'blur' }
        ],
        deviceType: [
          { required: true, message: '请输入设备类型', trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: '请选择所属公司', trigger: 'change' }
        ],
        greenhouseId: [
          { required: true, message: '请选择所属大棚', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择设备状态', trigger: 'change' }
        ]
      }
    }
  },

  mounted() {
    this.loadOptions();
    this.load();
  },

  methods: {
    load() {
      this.request.get('/api/equipment/sensor-devices/page', {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          name: this.searchName || undefined,
          companyId: this.searchCompanyId || undefined,
          greenhouseId: this.searchGreenhouseId || undefined
        }
      }).then(res => {
        if (res.code === "200") {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        }
      });
    },
    onCompanyFilterChange() {
      // 清空大棚选择并根据当前公司过滤可用大棚
      this.searchGreenhouseId = null;
      if (this.searchCompanyId) {
        this.filteredGreenhouses = this.greenhouses.filter(gh => gh.companyid === this.searchCompanyId);
      } else {
        // 如果未选择公司，恢复全部（对于非超级管理员，greenhouses 已经被过滤过）
        this.filteredGreenhouses = [...this.greenhouses];
      }
      this.load();
    },

    loadOptions() {
      // 加载公司和大棚选项
      this.request.get('/api/equipment/sensor-devices/options').then(res => {
        if (res.code === "200") {
          this.companies = res.data.companies || [];
          this.greenhouses = res.data.greenhouses || [];

          // 对于非超级管理员，根据当前用户的公司过滤大棚
          if (this.user.role !== '超级管理员') {
            const userCompanyId = this.user.companyid;
            this.greenhouses = this.greenhouses.filter(gh => gh.companyid === userCompanyId);
          }

          this.filteredGreenhouses = [...this.greenhouses];
        }
      });
    },

    handleAdd() {
      this.dialogTitle = '新增设备';
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
    },

    handleEdit(row) {
      this.dialogTitle = '编辑设备';
      this.isEdit = true;

      // 获取设备详情（包含字段信息）
      this.request.get(`/equipment/sensor-devices/${row.id}`).then(res => {
        if (res.code === "200") {
          const data = res.data;
          this.form = {
            id: data.device.id,
            deviceName: data.device.deviceName,
            sid: data.device.sid,
            deviceType: data.device.deviceType,
            deviceModel: data.device.deviceModel,
            deviceLocation: data.device.deviceLocation,
            status: data.device.status,
            companyId: data.device.companyId,
            greenhouseId: data.device.greenhouseId,
            fields: data.fields.length > 0 ? data.fields : [{
              sensorField: '',
              pid: '',
              unit: '',
            }]
          };
          this.onCompanyChange();
          this.dialogVisible = true;
        }
      });
    },

    handleDelete(id) {
      this.$confirm('确定删除该设备吗？删除后无法恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.delete(`/equipment/sensor-devices/${id}`).then(res => {
          if (res.code === "200") {
            this.$message.success('删除成功');
            this.load();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        });
      });
    },

    deleteBatch() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择要删除的设备');
        return;
      }

      this.$confirm(`确定删除选中的 ${this.multipleSelection.length} 个设备吗？删除后无法恢复。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.multipleSelection.map(item => item.id);
        this.request.delete('/api/equipment/sensor-devices/batch', { data: { ids } }).then(res => {
          if (res.code === "200") {
            this.$message.success(res.data || '批量删除成功');
            this.load();
          } else {
            this.$message.error(res.message || '批量删除失败');
          }
        });
      });
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const submitData = {
            deviceName: this.form.deviceName,
            sid: this.form.sid,
            deviceType: this.form.deviceType,
            deviceModel: this.form.deviceModel,
            deviceLocation: this.form.deviceLocation,
            status: this.form.status,
            companyId: this.form.companyId,
            greenhouseId: this.form.greenhouseId,
            fields: this.form.fields.filter(field =>
              field.sensorField.trim() !== '' &&
              field.pid.trim() !== ''
            )
          };

          const request = this.isEdit
            ? this.request.put(`/equipment/sensor-devices/${this.form.id}`, submitData)
            : this.request.post('/api/equipment/sensor-devices', submitData);

          request.then(res => {
            this.submitLoading = false;
            if (res.code === "200") {
              this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
              this.dialogVisible = false;
              this.load();
            } else {
              this.$message.error(res.message || (this.isEdit ? '编辑失败' : '新增失败'));
            }
          }).catch(() => {
            this.submitLoading = false;
            this.$message.error(this.isEdit ? '编辑失败' : '新增失败');
          });
        }
      });
    },

    resetForm() {
      this.form = {
        id: null,
        deviceName: '',
        sid: '',
        deviceType: '',
        deviceModel: '',
        deviceLocation: '',
        status: 0,
        companyId: this.user.role === '超级管理员' ? null : (JSON.parse(localStorage.getItem("user") || '{}').companyid || null),
        greenhouseId: null,
        fields: [{
          sensorField: '',
          pid: '',
          unit: '',
        }]
      };
      this.onCompanyChange();
    },

    handleDialogClose() {
      this.$confirm('确定关闭吗？未保存的数据将丢失。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogVisible = false;
      });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.load();
    },

    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.load();
    },

    addField() {
      this.form.fields.push({
        sensorField: '',
        pid: '',
        unit: ''
      });
    },

    removeField(index) {
      if (this.form.fields.length > 1) {
        this.form.fields.splice(index, 1);
      }
    },

    onCompanyChange() {
      if (this.form.companyId) {
        this.filteredGreenhouses = this.greenhouses.filter(gh => gh.companyid === this.form.companyId);
      } else {
        this.filteredGreenhouses = [...this.greenhouses];
      }
    },

    
  }
}
</script>

<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
</style>
